<template>
  <div
    class="bg-surface-default-low border-static-default-low overflow-y-auto border-r"
  >
    <RevAccordionList :has-external-borders="false">
      <ProductDetails />
      <Returns />
      <OrderHistory />
      <Warranty />
      <Customer />
      <Attachments />
      <Events />
    </RevAccordionList>
    <RevDivider />
    <p class="text-static-default-low p-16">
      <FormattedMessage class="body-1" :definition="translations.needHelp">
        <template #sscLink>
          <RevLink
            target="_blank"
            to="https://backmarket.my.site.com/ssc/s/submit-new-request"
          >
            <span class="text-static-default-low body-1-bold">
              {{ i18n(translations.SSCLinkLabel) }}
            </span>
          </RevLink>
        </template>
      </FormattedMessage>
    </p>
  </div>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionList } from '@ds/components/AccordionList'
import { RevDivider } from '@ds/components/Divider'
import { RevLink } from '@ds/components/Link'

import translations from './Details.translations'
import Attachments from './components/Attachments/Attachments.vue'
import Customer from './components/Customer/Customer.vue'
import Events from './components/Events/Events.vue'
import OrderHistory from './components/OrderHistory/OrderHistory.vue'
import ProductDetails from './components/ProductDetails/ProductDetails.vue'
import Returns from './components/Returns/Returns.vue'
import Warranty from './components/Warranty/Warranty.vue'

const i18n = useI18n()
</script>
